if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        document.body.classList.remove('product-media-modal-open');
      }

      show(opener) {
        super.show(opener);
        document.body.classList.add('product-media-modal-open');
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaItems = this.querySelectorAll('.product-media-modal__media');
        const thumbnails = this.querySelectorAll('.product-media-modal__thumbnail-item');

        if (mediaItems.length > 0) {
          const rawMediaId = this.openedBy?.getAttribute('data-media-id');
          let activeIndex = 0;

          // Match by exact ID or by suffix (thumbnail buttons omit the section prefix)
          mediaItems.forEach((item, index) => {
            const itemMediaId = item.getAttribute('data-media-id');
            if (
              itemMediaId === rawMediaId ||
              (rawMediaId && itemMediaId && itemMediaId.endsWith('-' + rawMediaId))
            ) {
              activeIndex = index;
            }
          });

          mediaItems.forEach((item, index) => {
            if (index === activeIndex) {
              item.classList.add('is-active');
              item.style.display = '';
            } else {
              item.classList.remove('is-active');
              item.style.display = 'none';
            }
          });

          thumbnails.forEach((thumb, index) => {
            const button = thumb.querySelector('button');
            if (index === activeIndex) {
              thumb.classList.add('is-active');
              button.setAttribute('aria-current', 'true');
            } else {
              thumb.classList.remove('is-active');
              button.removeAttribute('aria-current');
            }
          });
        } else {
          // Original layout for backwards compatibility
          this.querySelectorAll(
            `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
          ).forEach((element) => {
            element.classList.remove('active');
          });
          const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
          const activeMediaTemplate = activeMedia.querySelector('template');
          const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
          activeMedia.classList.add('active');
          activeMedia.scrollIntoView();

          const container = this.querySelector('[role="document"]');
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

          if (
            activeMedia.nodeName == 'DEFERRED-MEDIA' &&
            activeMediaContent &&
            activeMediaContent.querySelector('.js-youtube')
          )
            activeMedia.loadContent();
        }
      }
    }
  );
}
